import React from 'react';
import {inject, observer} from 'mobx-react';

@inject('preloaderStore')
@observer
export default class Preloader extends React.Component {

  render(){
    return (
       this.props.preloaderStore.isActive ?
      <div className="preloader-container">
        <span className="preloader-color"/>
        <div className="preloader-circle">
          <div className="md-preloader">
            <svg height="76" width="76">
              <circle cx="37.5" cy="37.5" r="33.5" strokeWidth="8"/>
            </svg>
          </div>
        </div>
      </div> : null
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/blocks/Preloader.jsx